import React from "react";
import { NavLink } from "react-router-dom";
const Header = () => {
    return (
        <header className="navbar navbar-expand-md navbar-dark">
            <div className="container">
                <NavLink className="navbar-brand" exact to="/">
                    Ailsa Lyn
                </NavLink>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#headerTabs"
                    aria-controls="headerTabs"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon" />
                </button>

                <div className="collapse navbar-collapse" id="headerTabs">
                    <div className="navbar-nav ml-auto">
                        <NavLink className="nav-item" exact to="/">
                            Home
                        </NavLink>
                        <NavLink className="nav-item" to="/gallery">
                            Gallery
                        </NavLink>
                        <NavLink className="nav-item" to="/commissions">
                            Commissions
                        </NavLink>
                        <NavLink className="nav-item" to="/sketch-a-day">
                            Sketch A Day
                        </NavLink>
                        <NavLink className="nav-item" to="/contact">
                            Contact
                        </NavLink>
                        <a
                            className="nav-item"
                            href="https://www.etsy.com/uk/shop/ailsalyn"
                        >
                            Shop
                        </a>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js